import { WiseOwlIngress } from "../types";

export const wiseOwlEndpoints = {
  getAccessToken: (ingress: WiseOwlIngress): string => `/auth/${ingress}`,
  getChats: "/chats",
  getChatById: (chatId: string): string => `/chats/${chatId}`,
  createChat: "/chats",
  updateChat: (chatId: string): string => `/chats/${chatId}`,
  createFeedback: (chatId: string, messageId: string) =>
    `/chats/${chatId}/messages/${messageId}/feedback`,
  getChatSummaryById: (chatId: string): string => `/chats/${chatId}/summary`,
  ungatedCreateChat: "/ungated/chats",
  ungatedUpdateChat: (chatId: string): string => `/ungated/chats/${chatId}`,
  ungatedCreateFeedback: (chatId: string, messageId: string) =>
    `/ungated/chats/${chatId}/messages/${messageId}/feedback`,
  ungatedGetChatSummaryById: (chatId: string): string =>
    `/ungated/chats/${chatId}/summary`,
};

export const wiseOwlApiDomain = {
  dev: "https://comms-gpt.aws-otk-dev-general-use1-001.otk.twilioinfra.com",
  stage: "https://comms-gpt.aws-otk-stage-general-use1-001.otk.twilioinfra.com",
  prod: "https://comms-gpt.aws-otk-prod-general-use1-001.otk.twilioinfra.com",
};
